import { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import { BackContext } from '../../../components/Main';
import PostulacionConcurso from './Aspirante/PostulacionConcurso';
import GestionConcursos from './Home/GestionConcursos';
import { EvaluacionDocumental } from './TramitarConcursos/CoordinadorConcursal/EtapaEvaluacionDocumental/EvaluacionDocumental';
import { fetchJurisdiccion } from './gestionConcursoSlice';

import TramiteConcurso from './TramitarConcursos/TramiteConcurso';

const HomeGestion = (props) => {
  const context = useContext(BackContext);

  const { path } = useRouteMatch();
  const location = useLocation();
  const dispatch = useDispatch();

  //Me aseguro de tener info básica
  useEffect(() => {
    dispatch(fetchJurisdiccion());
    //GestionConcursos lo sobreescribe para volver al home de nuevo
    context.setBackTo('/concursos');
    document.title = 'Concursar - Concursos';
  }, [location, dispatch]);

  return (
    <>
      <Switch>
        <Route exact path={path}>
          <GestionConcursos />
        </Route>
        <Route exact path={`${path}/tramitar`}>
          <TramiteConcurso />
        </Route>
        <Route exact path={`${path}/postulaciones/detalle_postulantes/:idPuesto`}>
          <EvaluacionDocumental key={''} />
        </Route>
        <Route exact path={`${path}/postularse`}>
          <PostulacionConcurso />
        </Route>
      </Switch>
    </>
  );
};

export default HomeGestion;
